import React from 'react';
import moment from 'moment';
import './UserDetails.css';

const present = value => value !== null && value !== undefined && String(value).trim() !== '';

export function processRegistration(user, processId) {
    const registration = user.inscricoes?.find(item => String(item.processo_id ?? item.processo?.id) === String(processId));
    return present(registration?.numero_inscricao) ? registration.numero_inscricao : (present(user.numero_inscricao) ? user.numero_inscricao : null);
}

export default function UserDetails({ user, candidate = false, fiscal = false, processId, identity = true, showRegistration = true }) {
    const fields = identity ? [['Nome', user.name], ['E-mail', user.email]] : [];
    if (candidate) {
        const cpf = String(user.cpf || '').replace(/\D/g, '');
        const birthValue = String(user.nascimento || '');
        const birth = birthValue ? moment(/^\d{4}-\d{2}-\d{2}/.test(birthValue) ? birthValue.slice(0, 10) : birthValue, ['YYYY-MM-DD', 'DD/MM/YYYY'], true) : null;
        fields.push(['CPF', cpf.length === 11 ? cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') : user.cpf]);
        fields.push(['Data de nascimento', birth?.isValid() ? birth.format('DD/MM/YYYY') : null]);
        if (showRegistration) fields.push(['Número de inscrição', processRegistration(user, processId)]);
    }
    if (fiscal) {
        const role = user.role || user.roles?.[0];
        const type = role?.description || ({ fiscal: 'Fiscal', fiscal_coordenador: 'Fiscal coordenador', fiscal_supervisor: 'Fiscal supervisor' })[role?.name || role];
        fields.push(['Tipo de fiscal', type]);
    }
    if (!fields.length) return null;
    return <dl className="user-details-grid">
        {fields.map(([label, value]) => <div className="user-details-field" key={label}><dt>{label}</dt><dd>{present(value) ? value : 'Não informado'}</dd></div>)}
    </dl>;
}
